<template>
  <div style="margin: 0 16px 16px">
    <el-button type="primary" style="margin-bottom: 16px;"  @click="addPet(-1)">添加宠物</el-button>
    <el-table
        ref="multipleTableRef"
        :data="petList"
        style="width: 100%; "
        v-loading="listLoading"
        size="default"
        border
    >
      <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
      <el-table-column property="name" label="宠物昵称"/>
      <el-table-column property="petBreedName" label="品种"/>
      <el-table-column property="petBreedColorName" label="花色"/>
      <el-table-column property="projectAllContent" label="毛长">
        <template #default="scope">
          {{scope.row.woolState == 1?'短毛':scope.row.woolState == 2?'长毛':''}}
        </template>
      </el-table-column>
      <el-table-column property="" label="绝育状态" width="100">
        <template #default="scope">
          {{scope.row.neuteringState == 1?'已绝育':scope.row.neuteringState == 2?'未绝育':'未知'}}
        </template>
      </el-table-column>
      <el-table-column property="description" label="特征" width="100"/>
      <el-table-column property="weight" label="体重（kg)" width="100"/>
      <el-table-column property="birthday" label="出生日期" width="100"/>
      <el-table-column property="nextInDriveDate" label="下次内驱时间" width="110"/>
      <el-table-column property="nextOutDriveDate" label="下次外驱时间" width="110"/>
      <el-table-column property="nextExemptionDate" label="下次疫苗时间" width="110"/>
      <el-table-column property="" label="编辑">
        <template #default="scope">
          <el-button type="text" @click="updatePet(scope.$index, scope.row)">编辑</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
<!--    <el-pagination background @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="totalRow" style="text-align:right;margin-top: 24px;">-->
<!--    </el-pagination>-->
  </div>
</template>

<script>
import { getFormData } from '@/api/api';
import {getAllShopList, pageUserConsumeList, getRecordShops, getPet} from '@/api/url';
import Dialog from '@/assets/js/dialog'
import Drawer from '@/assets/js/drawer'
import DatePickerRange from "@/components/DatePickerRange_30";
import SearchComponents from "@/components/SearchComponents";
import ConsumeDetailDialog from "@/views/user/components/ConsumeDetailDialog";
import AddOrUpdatePet from "@/views/user/components/AddOrUpdatePet";
export default {
  props: {
    value: Object
  },
  components: {DatePickerRange, SearchComponents},
  data() {
    return {
      petList: this.value.petList,
      userForm: this.value.userForm,
      userId: this.value.userId,
      editable: this.value.editable?this.value.editable:false,
      pageDataList: [],
      totalRow: 0,
      pageSize: 20,
      currentPage: 1,
      listLoading: false,
      searchLoading: false,
    }
  },
  methods: {

    checkDetail(idx, row) {
      let consumeForm = {}
      let consumeId = 0
      if(idx > -1) {
        consumeForm = Object.assign({}, row);
        consumeId = consumeForm.id
      }
      Dialog.open({
        title: '',
        component: ConsumeDetailDialog,
        data: {
          petList: this.petList,
          consumeId: consumeId,
          idx: idx
        },
        confirm: (result) => {
          this.getPage();
          // sessionStorage.setItem('recordState', JSON.stringify(true))
        }
      })
    },

    addPet(idx, row) {
      let _title = '';
      let petForm = {}
      _title = '添加宠物'
      Drawer.open({
        title: _title,
        component: AddOrUpdatePet,
        data: {
          petForm: petForm,
          ids: idx,
          userId: this.userForm.id,
          width: 600
        },
        confirm: (result) => {
          this.getPetInfo(idx, result)
        }
      })
    },

    updatePet(idx, row) {
      if(!this.editable) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '当前角色没有该门店的编辑权限',
          type: 'warning'
        });
        return false
      }


      getFormData(getPet, {id: row.id}).then(data => {
        let _title = '';
        let petForm = {}
        _title = '编辑宠物'
        petForm = data.data

        Drawer.open({
          title: _title,
          component: AddOrUpdatePet,
          data: {
            petForm: petForm,
            ids: idx,
            userId: this.userId,
            width: 600
          },
          confirm: (result) => {
            this.getPetInfo(idx, result)
            sessionStorage.setItem('recordState', JSON.stringify(true))
          }
        })

      })


    },

    getPetInfo(idx, result) {
      getFormData(getPet, {id: result}).then(data => {
        if(idx > -1) {
          this.petList[idx] = data.data
        }else {
          this.petList.push(data.data)
        }
      })
    },


  },
  mounted() {
  }
}
</script>

<style>

</style>
